"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALE_CONFIG = exports.DEFAULT_LOCALE = exports.DEFAULT_DATE_FORMAT = exports.DATE_FORMATS = void 0;
const DEFAULT_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = 'MM-dd-yyyy';
const DATE_FORMATS = exports.DATE_FORMATS = {
  'Default Format': DEFAULT_DATE_FORMAT,
  'date-month-year': 'dd-MM-yyyy',
  'year-month-date': 'yyyy-MM-dd',
  'month/date/year': 'MM/dd/yyyy',
  'date/month/year': 'dd/MM/yyyy',
  'year/month/date': 'yyyy/MM/dd',
  'Simple Date': 'MMM dd, yyyy',
  'Full Date': 'MMMM dd, yyyy',
  'Simple Day': 'EEE, dd MMM',
  'Full Day': 'EEEE, dd MMM',
  'Complete Full Day': 'EEE, dd MMM yyyy',
  'Short Full Simple Date': 'dd MMM yyyy',
  'Short Simple Date With No Year': 'dd MMM',
  'Short Simple Date': 'dd MMM'
};
const LOCALE_CONFIG = exports.LOCALE_CONFIG = {
  month: 'short',
  day: 'numeric'
};
const DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en-GB';